import _ from "lodash"
/**
 * filter the orders list based on filter values
 * !Note: for now its work with location and device filter
 * 
 * @param {array[object]} orders 
 * @param {object} filter 
 */
export function filterItems(orders, filter) {
   
    if(filter.status == null) return orders

    orders = _.filter(orders,(item) => {
        let order = {
            ...item,
            inprogress: item.inProgress == true ,
            approved: item.inProgress == false && item.isApproved == true,
            rejected: item.inProgress == false && item.isApproved == false,
            canceled: item.wasCanceled == true ,
            completed:  item.inProgress == false && item.isCompleted == true,
        }

        return itemHandler2(order, filter)
    });


    return orders
}

function itemHandler2(item, filter) {
    console.log({item, filter})
    let { status } = filter

   // for (var key in filter) {
       /* if (filter[key] !== null && (item[key] === undefined || (filter[key] && item[key] != filter[key].value)))
            return false;*/
        
    //}
    if( status == null || status.value && item[status.value] !== true)
    return false
    
    return true;
}